import React from 'react';
import Header from './Header';
import Hero from './Hero';
import Stats from './Stats';
import ProdukSection from './ProdukSection';
import KeuanganSection from './KeuanganSection';
import InformasiSection from './InformasiSection';
import Footer from './Footer';
import Login from '../Login';

const PublicLayout = () => {
  const [showLogin, setShowLogin] = React.useState(false);

  React.useEffect(() => {
    const handleHashChange = () => {
      if (window.location.hash === '#login') {
        setShowLogin(true);
      }
    };

    window.addEventListener('hashchange', handleHashChange);
    if (window.location.hash === '#login') {
      setShowLogin(true);
    }

    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  if (showLogin) {
    return <Login />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Hero />
      <Stats />
      <ProdukSection />
      <KeuanganSection />
      <InformasiSection />
      <Footer />
    </div>
  );
};

export default PublicLayout;